<div class="form relative w-full">
  @if (label()) {
    <smm-label
      [labelName]="label()"
      [required]="required()"
      [isOptional]="isOptional()"
      [labelIcon]="labelIcon()"
      [id]="formControlName"
      [isNewsletter]="isNewsletter()"
    ></smm-label>
  }
  @if (type() !== 'textarea') {
    <input
      [class.disabled]="disabled()"
      [ngClass]="[customeClass()]"
      [(ngModel)]="value"
      class="input__field"
      [type]="type()"
      [placeholder]="placeHolder() | translate"
      [id]="formControlName"
      (input)="detectValueChange($event.target)"
      [maxlength]="maxlength()"
      [disabled]="disabled()"
      (blur)="handleBlur($event)"
      [class]="isNewsletter() ? 'newsletter__input' : ''"
    />
  } @else {
    <textarea
      [class.disabled]="disabled()"
      [(ngModel)]="value"
      [ngClass]="[customeClass()]"
      [placeholder]="placeHolder() | translate"
      [id]="formControlName"
      (input)="detectValueChange($event.target)"
      [maxlength]="maxlength()"
      class="textarea__field"
    ></textarea>
  }
</div>
@if (control()?.invalid && (control()?.dirty || control()?.touched) && !customeError()) {
  <smm-input-error [control]="control()" />
}
